export class ObjetFactureDTO {
    static jsonMap = {
        id: { key: 'id', optional: true },
        idObjet: { key: 'idObjet' },
        fonctionnelId: { key: 'fonctionnelId' },
        idOperateur: { key: 'idOperateur' },
        idCahier: { key: 'idCahier', optional: true },
        annee: { key: 'annee' },
        quantite: { key: 'quantite' },
        codeRefQuantiteFacture: { key: 'codeRefQuantiteFacture', optional: true, default: '' }
    };

    id: number;
    idObjet: number;
    fonctionnelId: string;
    idOperateur: number;
    idCahier: number;
    annee: number;
    quantite: number;
    codeRefQuantiteFacture: string;
}
